import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';

import { ComponentColumn } from 'approot/activity-builder/components/component.constants';
import { ColumnPrintWrapper } from 'approot/activity-builder/components/columns/columns-print.style';
import { ComponentViewWrapper } from 'approot/activity-builder/components/components-view-wrapper.style';
import ActivityAnswersPrintComponent from './activity-answers-print-component';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/shared/component-settings-borders.utils';
import { getStyleProperties } from 'approot/activity-builder/components/components.utils';
import { LanguageCodes } from 'global/constants';

type Props = {
  column: ComponentColumn;
  onRenderComplete?: () => void;
  studentId?: number;
  previewType: string;
  language?: LanguageCodes;
  contentVersion: string | null | undefined;
};

const ActivityAnswersPrintColumnsComponents = ({
  column,
  language,
  onRenderComplete,
  studentId,
  previewType,
  contentVersion,
}: Props) => {
  const sortedComponents = useMemo(
    () => sortBy(column.components, 'sort'),
    [column.components]
  );

  return (
    <ColumnPrintWrapper>
      {sortedComponents.map(component => {
        return (
          <ComponentViewWrapper
            key={component.id}
            $colours={getAppliedColour(getStyleProperties(component))}
            $showBorder={isBorderApplied(getStyleProperties(component))}
            $showBackground={isBackgroundApplied(getStyleProperties(component))}
          >
            <ActivityAnswersPrintComponent
              component={component}
              onRenderComplete={onRenderComplete}
              studentId={studentId}
              previewType={previewType}
              language={language}
              contentVersion={contentVersion}
            />
          </ComponentViewWrapper>
        );
      })}
    </ColumnPrintWrapper>
  );
};

export default ActivityAnswersPrintColumnsComponents;
